<template>
  <CRow>
    <CCol>
      <CCard>
        <div class="judul">
          <strong>Detail Pengajuan</strong>
        </div>
        <CCardHeader>
          <strong>Data Diri Pendaftar</strong>
        </CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="ID Registration"
                class="mb-0"
                placeholder="ID Registration"
                v-model.trim="agentData.agent_id"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Bentuk Pengajuan"
                class="mb-0"
                placeholder="Bentuk Pengajuan"
                v-model.trim="agentData.registration_type"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Nama Pendaftar"
                class="mb-0"
                placeholder="Nama Pendaftar"
                v-model.trim="agentData.register_name"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Alamat Pendaftar"
                class="mb-0"
                placeholder="Alamat Pendaftar"
                v-model.trim="agentData.register_address"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="No HP"
                class="mb-0"
                placeholder="NO HP"
                v-model.trim="agentData.phone_number"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Email Pendaftar"
                class="mb-0"
                placeholder="Email Pendaftar"
                v-model.trim="agentData.register_email"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="No HP2"
                class="mb-0"
                placeholder="NO HP2 "
                v-model.trim="agentData.phone_number_two"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Darimana Anda mendapatkan informasi tentang pendaftaran ini"
                class="mb-0"
                v-model.trim="agentData.resource"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader v-if="agentData.registration_type === 'Badan Usaha'">
          <strong>Data Perusahaan</strong>
        </CCardHeader>
        <CCardBody v-if="agentData.registration_type === 'Badan Usaha'">
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Jenis Perusahaan"
                class="mb-0"
                placeholder="Jenis Perusahaan"
                v-model.trim="agentData.company_type"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Nama ketua perusahaan"
                class="mb-0"
                placeholder="Nama ketua perusahaan"
                v-model.trim="agentData.company_chairman_name"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Nama Perusahaan"
                class="mb-0"
                placeholder="Nama Perusahaan"
                v-model.trim="agentData.company_name"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Alamat Perusahaan"
                class="mb-0"
                placeholder="Alamat Perusahaan"
                v-model.trim="agentData.company_address"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader>
          <strong>Data Lokasi</strong>
        </CCardHeader>

        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Lokasi"
                class="mb-0"
                placeholder="Lokasi"
                v-model.trim="agentData.building_location"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Jenis Bangunan"
                class="mb-0"
                placeholder="Jenis Bangunan"
                v-model.trim="agentData.building_type"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Status Bangunan"
                class="mb-0"
                placeholder="Status Bangunan"
                v-model.trim="agentData.building_status"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Alamat Lokasi"
                class="mb-0"
                placeholder="Alamat Lokasi"
                v-model.trim="agentData.address_location"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Provinsi"
                class="mb-0"
                placeholder="Provinsi"
                v-model.trim="agentData.province"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Kota"
                class="mb-0"
                placeholder="Kota"
                v-model.trim="agentData.district"
                disabled
              />
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Kecamatan"
                class="mb-0"
                placeholder="Kecamatan"
                v-model.trim="agentData.sub_district"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Kelurahan"
                class="mb-0"
                placeholder="Kelurahan"
                v-model.trim="agentData.village"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader>
          <!-- <strong>Data Perusahaan</strong> -->
        </CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Apakah bersedia pickup ke customer?"
                class="mb-0"
                placeholder="Apakah bersedia pickup ke customer?"
                v-model.trim="isPickup"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Apakah ada pengalaman di bidang pengiriman/logistik?"
                class="mb-0"
                placeholder="Apakah ada pengalaman di bidang pengiriman/logistik?"
                v-model.trim="isLogistic"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Apakah ada kenalan online shop di wilayah anda?"
                class="mb-0"
                placeholder="Apakah ada kenalan online shop di wilayah anda?"
                v-model.trim="isLogistic"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Latitude & Longitude"
                class="mb-0"
                placeholder="Latitude & Longitude"
                v-model.trim="agentData.latlong"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Apakah bersedia melakukan drop off paket ke shuttle / konsolidator terdekat?"
                class="mb-0"
                placeholder="Apakah bersedia melakukan drop off paket ke shuttle / konsolidator terdekat?"
                v-model.trim="isDropOff"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Apakah bersedia melakukan Top Up pertama senilai Rp. 5.000.000?"
                class="mb-0"
                placeholder="Apakah bersedia melakukan Top Up pertama senilai Rp. 5.000.000?"
                v-model.trim="isTopUp"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader></CCardHeader>

        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6" v-if="agentData.referral_code !== undefined">
              <CInput
                label="Referral Code"
                class="mb-0"
                placeholder="Referral Code"
                v-model.trim="agentData.referral_code"
                disabled
              />
            </CCol>

            <CCol :col="6">
              <CInput
                label="Created Date"
                class="mb-0"
                placeholder="Created Date"
                v-model.trim="timeCreated"
                disabled
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol :col="6">
              <CInput
                label="Status Pengajuan"
                class="mb-0"
                v-model.trim="agentData.flag"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                placeholder="Please select"
                label="Action"
                :options="optionsAdjust"
                type="options"
                required
                @change="handleChooseFlag"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol :col="6" v-if="flag === 'REJECT'">
              <CSelect
                placeholder="Please select"
                label="Reason Reject"
                :options="optionsReject"
                type="options"
                required
                @change="handleSelectReject"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol :col="6" v-if="flag === 'APPROVE'">
              <CInput
                label="Note"
                class="mb-0"
                required
                placeholder="Input Some Reason"
                @change="handleReason"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="update"
                >Submit</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
        <CCardBody>
          <div class="judul">
            <strong>History Approval</strong>
          </div>

          <CDataTable
            hover
            :items="agentData.histories"
            :fields="fields"
          ></CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  name: "ListingAdJust",
  data() {
    return {
      agentData: {},
      timeCreated: "",
      agentDataUpdate: {},
      optionsAdjust: ["APPROVE", "REJECT"],
      optionsReject: [
        "Berdekatan dengan pos lain",
        "Lokasi kurang strategis",
        "Lokasi terlalu jauh dari perwakilan",
        "Belum ada perwakilan di area tersebut",
        "Nomor tidak dapat di hubungi",
        "Tidak melengkapi data",
        "Belum memiliki lokasi",
        "Hanya mencari informasi",
        "memiliki usaha sejenis",
      ],
      items: [],
      flag: "",
      flag2: "",
      fields: [
        { key: "flag", label: "Action" },
        { key: "flag", label: "Status Pengajuan" },
        { key: "reason", label: "Reason" },
        { key: "created_by", label: "Created By" },
        { key: "created_at", label: "Created Date" },
      ],
      createAgentData: {},
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      isPickup: "NO",
      isLogistic: "NO",
      isOlshop: "NO",
      isDropOff: "NO",
      isTopUp: "NO",
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },

  methods: {
    getDataByID() {
      let accountID = this.$route.params.id;
      axios
        .get(`${this.domain}/v1/agent/${accountID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.agentData = response.data;
          if (this.agentData.is_pickup === true) {
            this.isPickup = "YES";
          }
          if (this.agentData.is_logistic === true) {
            this.isLogistic = "YES";
          }
          if (this.agentData.is_olshop === true) {
            this.isOlshop = "YES";
          }
          if (this.agentData.is_drop_off === true) {
            this.isDropOff = "YES";
          }
          if (this.agentData.is_top_up === true) {
            this.isTopUp = "YES";
          }
          this.agentDataUpdate = response.data;
          this.timeCreated = moment(String(this.agentData.created_at)).format(
            "MM/DD/YYYY hh:mm A"
          );
          this.agentData.histories.forEach((element) => {
            element.created_at = moment(String(element.created_at)).format(
              "MM/DD/YYYY hh:mm A"
            );
          });
          this.items = [this.agentData];
        })
        .catch((e) => {
          console.log(e);
        });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/agent/listing" });
    },
    handleReason(event) {
      this.agentDataUpdate.reason = event;
    },
    handleSelectReject(event) {
      this.agentDataUpdate.reason = event.target.value;
    },
    handleChooseFlag(event) {
      this.flag = event.target.value;
    },

    update() {
      let accountID = this.$route.params.id;
      this.agentDataUpdate.flag = this.flag;
      axios
        .put(`${this.domain}/v1/agent/${accountID}`, this.agentDataUpdate, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Agent Data Updated`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/agent/listing/` });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message.id,
          });
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "./Agent.css";
</style>
